// Course Day constants

// Course Days
const courseDays = {
    UNSCHEDULED: 0,
    1: 1,
    2: 2,
    3: 3,
    4: 4,
}

// Only scheduled course days (all course days listed above besides 'ADDITIONAL')
const courseDaysScheduled = Object.fromEntries(
    Object.entries(courseDays).filter(([key, value]) => value !== courseDays.UNSCHEDULED)
)

Object.freeze(courseDays);
Object.freeze(courseDaysScheduled);

export default courseDays;
export {
    courseDays as COURSE_DAYS,
    courseDaysScheduled as COURSE_DAYS_SCHEDULED,
}